<template>
  <div class="table-search-container">
    <a-select
      style="width: 200px; margin-right: 20px"
      class="select-container"
      placeholder="请选择状态"
      @change="(value) => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-input-search
      placeholder="请输入搜索内容"
      style="width: 225px"
      allowClear
      @change="searchChange"
      @search="(value) => $emit('onSearch', value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增资讯
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statusData: [
        { id: "", name: "全部" },
        { id: 1, name: "显示" },
        { id: 2, name: "隐藏" },
      ],
    };
  },
  methods: {
    searchChange(e) {
      this.$emit("onSearch", e.data);
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
}
</style>
